export const maskAccountNumber = (value?: string) => {
  if (!value) return ``;

  const parsedValue = value.replace(/[^0-9]/gi, ``);
  if (parsedValue.length < 2) return parsedValue;
  return `${parsedValue.substring(0, parsedValue.length - 1)}-${parsedValue.substring(parsedValue.length - 1)}`;
};
